export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  paddingTop: '24px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const formControlsStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};
